module.exports = __webpack_public_path__ + "static/media/scale.49d859ba.svg";